import React, { useEffect, useState } from "react";
import salesTotalsCalculator from "../helpers/salesTotalsCalculator";
import getRecipientNamesByTour from "../requests/getRecipientNamesByTour";
import GigFinancialDataTableRow from "./GigFinancialDataTableRow";
import currencyFormat from "../helpers/currencyFormat";

const GigFinancialDataTable = ({ token, tourId, gigId, venueCut, sales, unhideVenueCutUpdateForm, userIsEditor }) => {

  const [ recipientNames, setRecipientNames ] = useState([]);

  useEffect(() => {
    if (token) {
      getRecipientNamesByTour(token, tourId).then(response => {
        // console.log(response);
        setRecipientNames(response.data);
      });
    }
  }, [token, tourId]);

  const totals = salesTotalsCalculator(sales, recipientNames);
  // console.log(totals);

  return (
    <table>
      <thead>
        <tr>
          <th className="left">product</th>
          <th className="center hideLtTablet">sold</th>
          <th className="center hideLtTablet">gifted</th>
          <th className="center hideLtTablet">paypal</th>
          <th className="right hideLtTablet">total revenue</th>
          <th className="right hideLtTablet">paypal comm.</th>
          <th className="right">net revenue</th>
          {
            recipientNames.length > 0 && recipientNames.map(name => {
              return (
                <th className="right">{name}</th>
              )
            })
          }
        </tr>
      </thead>
      <tbody>
      {
          sales.length === 0
          ?
          (
            <tr>
              <td colSpan="5">No Sales added yet</td>
            </tr>
          )
          :
          sales.map(sale => {
            return (
              <GigFinancialDataTableRow
                key={sale._id}
                sale={sale}
                recipientNames={recipientNames}
              />
            )
          })
        }
      </tbody>
      <tfoot>
        <tr className="totals">
          <td>totals</td>
          <td className="center hideLtTablet">{totals.numberSold}</td>
          <td className="center hideLtTablet">{totals.numberGifted}</td>
          <td className="center hideLtTablet">{totals.numberPaypal}</td>
          <td className="right hideLtTablet">{currencyFormat(totals.totalRevenue / 100)}</td>
          <td className="right hideLtTablet">{currencyFormat(totals.paypalCommission / 100)}</td>
          <td className="right">{currencyFormat(totals.netRevenue / 100)}</td>
          {
            recipientNames.length > 0 && recipientNames.map(recipientName => {
              const recipient = totals.recipientShares
                .find(recipientShare => recipientShare.name === recipientName)
                || { name: "", share: 0 };
              return (
                <td className="right">{currencyFormat(recipient.share / 100)}</td>
              )
            })
          }
        </tr>
        <tr className="totals">
            <td>less: venue cut</td>
            <td colspan="5" className="hideLtTablet"></td>
            <td className="right">{currencyFormat(venueCut / 100)}</td>
            <td colspan={recipientNames.length}>
              {
                userIsEditor &&
                (
                  <button className="button-link" onClick={unhideVenueCutUpdateForm}>Update</button>
                )
              }
            </td>
          </tr>
          <tr className="totals">
            <td>Net Total</td>
            <td colspan="5" className="hideLtTablet"></td>
            <td className="right">{currencyFormat((totals.netRevenue - venueCut) / 100)}</td>
            {
              recipientNames.map(n => {
                return (<td></td>)
              })
            }
          </tr>
      </tfoot>
    </table>
  )

};

export default GigFinancialDataTable;